module.exports = __webpack_public_path__ + "static/img/penguin.46b28f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/poll/penguin.png
// module id = 3007
// module chunks = 1